// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__T0kNN","footer":"ModalError_footer__3zg9L"};